<!--
 * @Description: 服务有效期
 * @Date: 2025-09-12 17:45:57
-->
<template>
  <BaseTextTitle>
    <span style="margin-right: 15px">服务有效期</span>
    <!-- 详情、审核都可一致新增 -->
    <!-- 长期则不可新增 -->
    <BaseButton @click="onAdd" :disabled="!!formData.isPermanent">
      新增延期
    </BaseButton>
    <!-- 长期为1展示，且不可编辑 -->
    <BaseCheckbox
      v-if="formData.isPermanent"
      disabled
      :true-value="1"
      :false-value="0"
      v-model="formData.isPermanent"
      @change="onChangePermanent"
    >
      长期有效
    </BaseCheckbox>
  </BaseTextTitle>
  <BaseTextContent>
    <BaseForm ref="ruleFormRef" :model="formData">
      <BaseFormItem
        label="服务有效期"
        prop="_expira"
        :rules="[
          {
            required: true,
            message: '请选择',
            trigger: 'change',
            validator(_rule, value, callback) {
              if (!value.length && !formData.isPermanent) {
                callback(new Error('请选择'));
              } else {
                callback();
              }
            }
          }
        ]"
      >
        <div style="width: 100%">
          {{ formatDates(formData._expira) }}
          <!-- <BaseDatePicker
            type="daterange"
            placeholder="请选择"
            validate-event
            :disabled="disabled"
            v-model:value="formData._expira"
          /> -->
        </div>
      </BaseFormItem>
      <BaseFormItem label="延期日期" prop="">
        <div>
          <template v-for="(item, index) in historyDates" :key="index">
            <div style="width: 100%">
              {{ formatDates(historyDates[index]) }}
              <!-- <BaseDatePicker
                type="daterange"
                placeholder="请选择"
                v-model:value="historyDates[index]"
                disabled
                validate-event
              /> -->
            </div>
          </template>
        </div>
      </BaseFormItem>
    </BaseForm>
  </BaseTextContent>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue';
import {
  BaseTextContent,
  BaseTextTitle,
  useCreateModal,
  BaseButton,
  BaseForm,
  BaseFormItem,
  BaseCheckbox
} from 'xrk-components';
import DetailAddTimeDialog from './add-time-dialog.vue';
import { IndividualInfoDetailData } from '../../data-source/types';
import { formatter } from '@/utils';

const emits = defineEmits(['success']);

const ruleFormRef = ref();
const formData = defineModel<IndividualInfoDetailData>();
const historyDates = ref([]);

watch(
  () => formData.value,
  v => {
    if (v.historyExpiraDateList.length) {
      historyDates.value = v.historyExpiraDateList.reduce((pre, cur) => {
        pre.push([cur.startAt, cur.endAt]);
        return pre;
      }, []);
    }
  },
  {
    immediate: true,
    deep: true
  }
);

const formatDates = dates => {
  if (!dates.length) return '';
  return dates
    .map(item => {
      return formatter.date(item, 'YYYY-MM-DD');
    })
    .join(' ~ ');
};
const onAdd = () => {
  useCreateModal(DetailAddTimeDialog, {
    id: formData.value.id,
    expiraEnd: formData.value.expiraEnd,
    registerAt: formData.value.registerAt,
    historyExpiraDateList: formData.value.historyExpiraDateList,
    onSuccess: () => {
      emits('success');
    }
  });
};
const onChangePermanent = val => {
  if (val) {
    formData.value._expira = [];
  }
};

defineExpose({
  validate: () => {
    return ruleFormRef.value.validate();
  }
});
</script>
